import { NavLink } from "react-router-dom";
import { TbHome, TbFlask2 } from "react-icons/tb";
import BotFace from "../../design-system/icons/BotFace.jsx";

const NAV_ITEMS = [
  { label: "Home", icon: TbHome, to: "/" },
  { label: "Bot", icon: BotFace, to: "/bot" },
  { label: "Forward Test", icon: TbFlask2, to: "/forward-testing" },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 desktop:hidden bg-white border-t border-gray-200 flex items-stretch h-16">
      {/* icon-only — label kept as the accessible name, not rendered text */}
      {NAV_ITEMS.map(({ label, icon: Icon, to }) =>
        to ? (
          <NavLink
            key={label}
            to={to}
            end
            aria-label={label}
            className="flex-1 relative flex items-center justify-center"
          >
            {({ isActive }) => (
              <>
                <span
                  className={`flex items-center justify-center w-11 h-9 rounded-xl transition-colors ${
                    isActive ? "bg-[#ECEAF8] text-[#5B3DF6]" : "text-[#697077]"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </span>
                {isActive && (
                  <span className="absolute bottom-1.5 w-5 h-0.5 rounded-full bg-[#5B3DF6]" />
                )}
              </>
            )}
          </NavLink>
        ) : (
          <button
            key={label}
            type="button"
            aria-label={label}
            className="flex-1 flex items-center justify-center text-[#697077]"
          >
            <span className="flex items-center justify-center w-11 h-9 rounded-xl">
              <Icon className="w-5 h-5" />
            </span>
          </button>
        )
      )}
    </nav>
  );
}
